import { SubscriptionLike as ISubscription, Subject } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { BodyPaintManualService } from '../../body-and-paint-manual/body-paint-manual.service';
import { BulletinService } from '../../servicebulletin/bulletin.service';
import { TechnicalDocumentationService } from '../../technical-documentation/technical-documentation.service';
import { TriBulletinService } from '../../tri-bulletins-home/tri-bulletin.service';
// tslint:disable-next-line:max-line-length
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { HandleError } from '../../../core/models/handle-error';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { OnboardDiagnosticService } from '../../onboard-diagnostic/onboard-diagnostic.service';
import { OperatingFluidsService } from '../../operating-fluids/operating-fluids.service';
import { PartsBulletinsService } from '../../parts-bulletins/parts-bulletins.service';
import { TechTrainingManualService } from '../../tech-training-manual/tech-training-manual.service';
import { ToolsAndEquipmentManualsService } from '../../tool-report/tools-and-equipment-manuals.service';
import { SearchResultsService } from '../search-results.service';
//import { takeUntil } from 'rxjs/operators';
import { APP_SETTINGS } from '@services';
import { NgIf, NgFor, NgStyle, DatePipe } from '@angular/common';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';
import { FilterResultsPipe } from '../../../shared/pipes/filter-results.pipe';
import { SortResultsPipe } from '../../../shared/pipes/sort-results.pipe';
import { LimitResultsPipe } from '../../../shared/pipes/limit-results.pipe';

@Component({
    selector: 'app-results-content',
    templateUrl: './search-results-content.component.html',
    styleUrls: ['./search-results-content.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        NgStyle,
        RouterLink,
        DatePipe,
        HighlightSearchPipe,
        FilterResultsPipe,
        SortResultsPipe,
        LimitResultsPipe,
    ],
})
export class SearchResultsContentComponent implements OnInit, OnDestroy {

  public bulletinApiData: any[];
  public bulletinApiDataObject = {};
  public bulletinApiDataObjectKeys = [];
  private bulletinApiDataCopy: any[];
  public bulletinCoSectionApiData: any[];
  public bulletinCoSectionApiDataCopy: any[];
  public filter = { group: '', series: '', body: '', from: '', to: '' };
  public sortBy = '';
  public limit = 0;
  private subscription: ISubscription[] = [];
  public loadingInfo = '';
  APP_SETTINGS: any;
  private selectedBranch = '';
  public isExternal: boolean; //ASENGG-29592 Technical Documentation solr search fix for external users
  private componentDestroyed: Subject<boolean> = new Subject();

  private username: string;
  results_count: number;

  public apiCheck: number;

  screenWidth: number;

  @Output()
  resultsCount: EventEmitter<number> = new EventEmitter<number>();

  // results limit input from parent results. listen to change detections using setter
  @Input()
  set resultsLimit(resultsLimit: number) {
    if (resultsLimit > 0) {
      if (this.bulletinApiData && this.bulletinCoSectionApiData) {
        this.limit = Math.floor(resultsLimit / 2);
      } else if (this.bulletinApiData) {
        this.limit = resultsLimit;
      }
    }
  }

  // @Input()
  // set selectSortBy(selectSortBy: string) {
  // if (selectSortBy === 'Most Recent') {
  //   this.sortBy = 'releaseDate';
  // } else if (selectSortBy === 'Most Relevant') {
  //   this.sortBy = 'id';
  // } else {
  //   this.fetchApi();
  // }
  // }

  // bulletinLabel addedd for is Motorrad --Vishal
  bulletinLabel = 'TRI Bulletins';
  userRoles = {};

  public searchKey: string;
  public dateFormat: string;
  public search_section: string;

  public serviceError = 'Loading data. Please wait...';
  public serviceCoError = 'Loading data. Please wait...';
  constructor(private searchResultsService: SearchResultsService,
    private route: ActivatedRoute,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private spinnerService: SpinnerService,
    private utilityService: UtilityService,
    private bulletinService: BulletinService,
    private triBulletinService: TriBulletinService,
    private partsBulletinService: PartsBulletinsService,
    private operatingFluidService: OperatingFluidsService,
    private obdService: OnboardDiagnosticService,
    private toolsAndEquipManualService: ToolsAndEquipmentManualsService,
    private techDocService: TechnicalDocumentationService,
    private techTrainingManualService: TechTrainingManualService,
    private authService: AuthService,
    private bodyPaintManualService: BodyPaintManualService,
    // private state: RouterStateSnapshot
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
    this.searchKey = this.route.snapshot.queryParams['key'];
  }


  ngOnInit() {

    //ASENGG-29592 Technical Documentation solr search fix for external users
    this.APP_SETTINGS = APP_SETTINGS;
    this.isExternal = this.APP_SETTINGS['isExternal'];

    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
    APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
    
    if (APP_SETTINGS.isBMW === "true") {
      this.selectedBranch="BMW";  
    }
    if (APP_SETTINGS.isMINI === "true") {
      this.selectedBranch="MINI";
    }
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.bulletinLabel = "Authority Bulletins";
      this.selectedBranch="MOTORRAD";
    }
    if (APP_SETTINGS.isRollsRoyce === "true") {
      this.selectedBranch="ROLLSROYCE";
    }
    
    this.APP_SETTINGS = APP_SETTINGS;

    this.username = this.authService.getUserName();
    this.searchKey = '';
    this.dateFormat = 'yyyy-MM-dd';
    this.search_section = this.route.snapshot.queryParams['section'] || this.route.snapshot.paramMap.get('section');
    this.searchKey = this.route.snapshot.queryParams['key'];
    if (this.searchKey) {
      localStorage.setItem('SEARCH_KEY', this.searchKey);
    }
    this.fetchApi();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.route.snapshot.url[0].path === 'results') {
          const section = this.route.snapshot.paramMap.get('section');
          this.search_section = section.toLowerCase();
          // this.fetchApi();
          this.limit = 0;
        }
      }
    });

    // listen to changes in dropdown value of header
    this.subscription.push(this.utilityService.emit_dropdown$.subscribe(value => {
      this.search_section = value.toLowerCase();
      this.changeDetector.detectChanges();
      this.fetchApi();
    }));

    this.subscription.push(this.utilityService.filterCriteria$.subscribe(value => {
      this.filter = value;
      this.changeDetector.detectChanges();
    }));


    // this.subscription.push(this.utilityService.filterCriteria$.subscribe(value => {
    //   this.filter = value;
    //   if (value.hasOwnProperty('sort')) {
    //     if (value.sort === 'Most Recent') {
    //       this.sortBy = 'releaseDate';
    //     } else if (value.sort === 'Most Relevant') {
    //       this.sortBy = 'id';
    //     } else {
    //       this.fetchApi();
    //     }
    //     this.filter.body = '';
    //   }
    //   this.changeDetector.detectChanges();
    // }));

    // listen to changes in input box of header
    this.subscription.push(this.utilityService.emit_search_key$.subscribe(value => {
      this.searchKey = value.trim();
      localStorage.setItem('SEARCH_KEY', this.searchKey);
      this.changeDetector.detectChanges();
    }));
  }

  navigateToSection(section) {
    this.router.navigate(['/results', section]);
    this.utilityService.changeDropdown(section);
  }

  // get all sections json data
  async fetchApi() {
    this.results_count = 0;
    const cachedSearchKey = localStorage.getItem('SEARCH_KEY');
    this.searchKey = this.searchKey || cachedSearchKey;
    if (this.searchKey && this.searchKey.trim().length > 0) {
      this.serviceError = '';
      this.serviceCoError = '';
      switch (this.search_section.trim()) {
        case 'all':
          this.bulletinApiData = [];
          Object.keys(this.bulletinApiDataObject).forEach(content => this.bulletinApiDataObject[content] = []);
          this.results_count = 0;
          this.limit = 0;

          this.spinnerService.show('bmwSpinner');

          await this.searchResultsService.getBulletinsServiceData(this.searchKey)
            .toPromise()
            .then(result => {
              this.loadingInfo = 'Loading....';
              this.bulletinApiDataObject['Service Bulletins'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
              // this.emitResultCount(this.results_count);
              // this.spinnerService.hide('bmwSpinner');
            })
            .catch(error => {
              console.error('Error retrieving bulletin data');
            });


          


          await this.searchResultsService.getPartsBulletinsData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
                result = result.filter( pbsBulletin => (pbsBulletin.bulletinFile != null && pbsBulletin.bulletinFile.fileName != null) ); 
                this.bulletinApiDataObject['Parts Bulletins'] = result.slice(0, 10);

                this.results_count = this.results_count + result.length;
                // this.emitResultCount(this.results_count);
                if (!this.changeDetector['destroyed']) {
                  this.changeDetector.detectChanges();
                }
              }
            })
            .catch(error => {
              this.spinnerService.hide("bmwSpinner");
              console.error('Error retrieving Parts Bulletin data');
            });


          await this.searchResultsService.getTechTrainingManualsData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
                this.bulletinApiDataObject['Technical Training Manuals'] = result.slice(0, 10);
                this.results_count = this.results_count + result.length;
                // this.emitResultCount(this.results_count);
                if (!this.changeDetector['destroyed']) {
                  this.changeDetector.detectChanges();
                }
              }
            })
            .catch(error => {

            });


          await this.searchResultsService.getBodyAndPaintManualsData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
              this.bulletinApiDataObject['Body & Paint Manuals'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving Body And Paint Manual data');
            });


          await this.searchResultsService.getOperatingFluidsData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
              this.bulletinApiDataObject['Operating Fluids'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving Operating Fluids data');
            });

          //ASENGG-29592 Fix tech docs solr search not allowed for thir partie users
          if (this.APP_SETTINGS.isExternal == 'false') {
            await this.searchResultsService.getTechnicalDocumentationData(this.searchKey)
              .toPromise()
              .then(result => {
                if (result) {
                  this.bulletinApiDataObject['Technical Documentation'] = result.slice(0, 10);
                  this.results_count = this.results_count + result.length;
                  // this.emitResultCount(this.results_count);
                  if (!this.changeDetector['destroyed']) {
                    this.changeDetector.detectChanges();
                  }
                }
              })
              .catch(error => {
                console.error('Error retrieving Techinical Documentation data');
              });
          }

          await this.searchResultsService.getOBDData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
              this.bulletinApiDataObject['Onboard Diagnostic (OBD)'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving OBD data');
            });


          await this.searchResultsService.getEquipementManualsData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
              this.bulletinApiDataObject['Equipment Manuals'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving Equipment Manuals data');
            });


          await this.searchResultsService.getToolsData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
              this.bulletinApiDataObject['Tools Report'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving Tools data');
            });


          await this.searchResultsService.getTopLinksData(this.searchKey)
            .toPromise()
            .then(result => {
              if ( result ) {
              this.bulletinApiDataObject['Top Links'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving Top Links data');
            });


          await this.searchResultsService.getFAQsData(this.searchKey)
            .toPromise()
            .then(result => {
              this.loadingInfo = '';
              if ( result ) {
              this.bulletinApiDataObject['FAQs'] = result.slice(0, 10);
              this.results_count = this.results_count + result.length;
              // this.emitResultCount(this.results_count);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            }
            })
            .catch(error => {
              console.error('Error retrieving FAQs data');
            });

          this.apiCheck = this.results_count;
          this.emitResultCount(this.results_count);
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = '';

          break;
        case 'sib':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getBulletinsServiceData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              const resultCount = this.bulletinApiData.length;
              if (resultCount === 0) {
                this.serviceError = 'No records Found';
              }
              this.bulletinCoSectionApiData = null;
              this.emitResultCount(resultCount);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'pbs':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getPartsBulletinsData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              this.bulletinApiData = this.bulletinApiData.filter( pbsBulletin => (pbsBulletin.bulletinFile != null && pbsBulletin.bulletinFile.fileName != null) ); 
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }
              this.bulletinCoSectionApiData = null;
              this.emitResultCount(this.bulletinApiData.length);
              this.changeDetector.detectChanges();
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'tri':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getTRIBulletinsData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }
              this.bulletinCoSectionApiData = null;
              this.emitResultCount(this.bulletinApiData.length);
              if (!this.changeDetector['destroyed']) {
                this.changeDetector.detectChanges();
              }
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'of':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getOperatingFluidsData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }
              this.bulletinCoSectionApiData = null;
              this.emitResultCount(this.bulletinApiData.length);
              this.changeDetector.detectChanges();
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'tm':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getTechTrainingManualsData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }
              this.searchResultsService.getBodyAndPaintManualsData(this.searchKey)
                .subscribe(
                value => {
                  // converting object returned by api to array
                  if (value) {
                    this.bulletinCoSectionApiData = value;
                    if (this.bulletinCoSectionApiData.length === 0) {
                      this.serviceCoError = 'No records Found';
                    }
                  }
                  this.emitResultCount(this.bulletinApiData.length + this.bulletinCoSectionApiData.length);
                  if (!this.changeDetector['destroyed']) {
                    this.changeDetector.detectChanges();
                  }
                 //  this.changeDetector.detectChanges();
                }
                );
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'faq':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getTopLinksData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }
              this.searchResultsService.getFAQsData(this.searchKey)
                .subscribe(
                value => {
                  // converting object returned by api to array
                  if (value) {
                    this.bulletinCoSectionApiData = value;
                    if (this.bulletinCoSectionApiData.length === 0) {
                      this.serviceCoError = 'No records Found';
                    }
                  }
                  this.emitResultCount(this.bulletinApiData.length + this.bulletinCoSectionApiData.length);
                  this.changeDetector.detectChanges();
                }
                );
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'obd':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getOBDData(this.searchKey)
            .subscribe(
            data => {
              this.spinnerService.hide('bmwSpinner');
              this.bulletinApiData = data;
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }
              this.bulletinCoSectionApiData = null;
              this.emitResultCount(this.bulletinApiData.length);
              this.changeDetector.detectChanges();
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'te':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          this.spinnerService.show('bmwSpinner');
          this.searchResultsService.getEquipementManualsData(this.searchKey)
            .subscribe(
            data => {
              
              this.bulletinApiData = data;
              if (this.bulletinApiData.length === 0) {
                this.serviceError = 'No records Found';
              }


              this.searchResultsService.getToolsData(this.searchKey)
                .subscribe(
                value => {
                  this.spinnerService.hide('bmwSpinner');
                  this.bulletinCoSectionApiData = value;
                  if (this.bulletinCoSectionApiData.length === 0) {
                    this.serviceCoError = 'No records Found';
                  }
                  
                  this.emitResultCount(this.bulletinApiData.length + this.bulletinCoSectionApiData.length);
                  if (!this.changeDetector['destroyed']) {
                    this.changeDetector.detectChanges();
                  }
                }
                );
            },
            error => {
              this.serviceError = 'No records Found';
              this.emitResultCount(0);
              this.spinnerService.hide('bmwSpinner');
              this.serviceError = HandleError.handleAPIError(error);
            }
            );
          break;
        case 'td':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
           //ASENGG-29592 Fix tech docs solr search not allowed for third partie users
          if (this.APP_SETTINGS.isExternal == 'false') {
            this.spinnerService.show('bmwSpinner');
            this.searchResultsService.getTechnicalDocumentationData(this.searchKey)
              .subscribe(
                data => {
                  this.spinnerService.hide('bmwSpinner');
                  this.bulletinApiData = data;
                  if (this.bulletinApiData.length === 0) {
                    this.serviceError = 'No records Found';
                  }
                  this.bulletinCoSectionApiData = null;
                  this.emitResultCount(this.bulletinApiData.length);
                  this.changeDetector.detectChanges();
                },
                error => {
                  this.serviceError = 'No records Found';
                  this.emitResultCount(0);
                  this.spinnerService.hide('bmwSpinner');
                  this.serviceError = HandleError.handleAPIError(error);
                }
              );
          }
          break;
        case 'adv':
          this.bulletinApiData = [];
          this.bulletinCoSectionApiData = [];
          break;
      }
    } else {
      this.serviceError = 'Please enter the value or Click Search button to view results';
    }
  }

  getLengthOf(apiData) {
    return Object.keys(apiData).map(key => this.bulletinApiData[key].content.length).reduce((a, b) => a + b);
  }

  addDocToHistory(docType, id) {
    switch (docType) {
      case 'sib':
        this.subscription.push(this.bulletinService.addBulletinToUserHistory(this.username, id).subscribe());
        break;
      case 'pbs':
        this.subscription.push(this.triBulletinService.addBulletinToUserHistory(this.username, id).subscribe());
        break;
      case 'tri':
        this.subscription.push(this.partsBulletinService.addBulletinToUserHistory(this.username, id).subscribe());
        break;
      case 'of':
        this.subscription.push(this.operatingFluidService.addManualToUserHistory(this.username, id).subscribe());
        break;
      case 'tm':
        this.subscription.push(this.techTrainingManualService.addManualToUserHistory(this.username, id).subscribe());
        break;
      case 'bpm':
        this.subscription.push(this.bodyPaintManualService.addManualToUserHistory(this.username, id).subscribe());
        break;
      case 'obd':
        this.subscription.push(this.obdService.addOBDManualToUserHistory(this.username, id).subscribe());
        break;
      case 'em':
        this.subscription.push(this.toolsAndEquipManualService.addReportToUserHistory(this.username, id).subscribe());
        break;
      case 'tools':
        this.subscription.push(this.toolsAndEquipManualService.addReportToUserHistory(this.username, id).subscribe());
        break;
      case 'td':
        this.subscription.push(this.techDocService.postUserTechDocHistory(this.username, id).subscribe());
        break;
    }
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  // slice the copy version of the array and save the tailored result to original array
  // showLimitedResultsPerPage(apiData, apiData2, limit) {
  //   if (apiData.constructor === Object) {
  //     let limitPerSection = Math.ceil(limit / Object.keys(apiData2).length);
  //     limitPerSection = limitPerSection < 1 ? 1 : limitPerSection;
  //     Object.keys(apiData).forEach(key => {
  //       const content = apiData2[key].content.slice(0, limitPerSection);
  //       apiData[key] = { ...apiData[key], content };
  //     });
  //     return apiData;
  //   } else {
  //     if (+limit < apiData2.length) {
  //       return apiData2.slice(0, limit);
  //     } else {
  //       return apiData2;
  //     }
  //   }

  // }

  emitResultCount(count: number) {
    this.resultsCount.emit(count);
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
    this.changeDetector.detach();
    this.componentDestroyed.next(true);
    this.componentDestroyed.complete();
  }
}
